import { defineStore } from "pinia";
import axios from "axios";

export const useRequestHelpStore = defineStore("requestHelp", {
  state: () => ({
    helpStatus: [
      {
        id: 1,
        name: "รอความช่วยเหลือ",
      },
      {
        id: 2,
        name: "รอความช่วยเหลือ",
      },
      {
        id: 3,
        name: "ปฏิเสธ",
      },
      {
        id: 4,
        name: "กำลังช่วยเหลือ",
      },
      {
        id: 5,
        name: "สำเร็จ",
      },
      {
        id: 6,
        name: "ล้มเหลว",
      },
      {
        id: 7,
        name: "สำเร็จ",
      },
    ],
  }),

  actions: {
    async getProductRequest(query) {
      try {
        const response = await axios.get("/product-requests", {
          params: query,
        });
        if (response.status === 200 || response.status === 201) {
          // console.log("GET :", response.data);
          return response.data;
        }
      } catch (error) {
        console.error("GET ERR :", error);
        throw error;
      }
    },

    async getProductRequestById(id, query) {
      try {
        const response = await axios.get(`/shelter-requests/${id}`, {
          params: query,
        });
        if (response.status === 200 || response.status === 201) {
          // console.log("GET :", response.data);
          return response.data;
        }
      } catch (error) {
        console.error("GET ERR :", error);
        throw error;
      }
    },
  },
});
